/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  TextAreaField,
  TextField,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { API } from "aws-amplify";
import { createBranch } from "../graphql/mutations";
export default function BranchCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    customId: "",
    name: "",
    abbreviation: "",
    address: "",
    phone: "",
    country: "",
    city: "",
    description: "",
  };
  const [customId, setCustomId] = React.useState(initialValues.customId);
  const [name, setName] = React.useState(initialValues.name);
  const [abbreviation, setAbbreviation] = React.useState(
    initialValues.abbreviation
  );
  const [address, setAddress] = React.useState(initialValues.address);
  const [phone, setPhone] = React.useState(initialValues.phone);
  const [country, setCountry] = React.useState(initialValues.country);
  const [city, setCity] = React.useState(initialValues.city);
  const [description, setDescription] = React.useState(
    initialValues.description
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setCustomId(initialValues.customId);
    setName(initialValues.name);
    setAbbreviation(initialValues.abbreviation);
    setAddress(initialValues.address);
    setPhone(initialValues.phone);
    setCountry(initialValues.country);
    setCity(initialValues.city);
    setDescription(initialValues.description);
    setErrors({});
  };
  const validations = {
    customId: [{ type: "Required" }],
    name: [{ type: "Required" }],
    abbreviation: [],
    address: [],
    phone: [{ type: "Phone" }],
    country: [],
    city: [],
    description: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          customId,
          name,
          abbreviation,
          address,
          phone,
          country,
          city,
          description,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await API.graphql({
            query: createBranch.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "BranchCreateForm")}
      {...rest}
    >
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid0")}
      >
        <TextField
          label="Identificator"
          isRequired={true}
          isReadOnly={false}
          value={customId}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                customId: value,
                name,
                abbreviation,
                address,
                phone,
                country,
                city,
                description,
              };
              const result = onChange(modelFields);
              value = result?.customId ?? value;
            }
            if (errors.customId?.hasError) {
              runValidationTasks("customId", value);
            }
            setCustomId(value);
          }}
          onBlur={() => runValidationTasks("customId", customId)}
          errorMessage={errors.customId?.errorMessage}
          hasError={errors.customId?.hasError}
          {...getOverrideProps(overrides, "customId")}
        ></TextField>
        <TextField
          label="Name"
          isRequired={true}
          isReadOnly={false}
          value={name}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                customId,
                name: value,
                abbreviation,
                address,
                phone,
                country,
                city,
                description,
              };
              const result = onChange(modelFields);
              value = result?.name ?? value;
            }
            if (errors.name?.hasError) {
              runValidationTasks("name", value);
            }
            setName(value);
          }}
          onBlur={() => runValidationTasks("name", name)}
          errorMessage={errors.name?.errorMessage}
          hasError={errors.name?.hasError}
          {...getOverrideProps(overrides, "name")}
        ></TextField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(3, auto)"
        {...getOverrideProps(overrides, "RowGrid1")}
      >
        <TextField
          label="Abbreviation"
          isRequired={false}
          isReadOnly={false}
          value={abbreviation}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                customId,
                name,
                abbreviation: value,
                address,
                phone,
                country,
                city,
                description,
              };
              const result = onChange(modelFields);
              value = result?.abbreviation ?? value;
            }
            if (errors.abbreviation?.hasError) {
              runValidationTasks("abbreviation", value);
            }
            setAbbreviation(value);
          }}
          onBlur={() => runValidationTasks("abbreviation", abbreviation)}
          errorMessage={errors.abbreviation?.errorMessage}
          hasError={errors.abbreviation?.hasError}
          {...getOverrideProps(overrides, "abbreviation")}
        ></TextField>
        <TextField
          label="Address"
          isRequired={false}
          isReadOnly={false}
          value={address}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                customId,
                name,
                abbreviation,
                address: value,
                phone,
                country,
                city,
                description,
              };
              const result = onChange(modelFields);
              value = result?.address ?? value;
            }
            if (errors.address?.hasError) {
              runValidationTasks("address", value);
            }
            setAddress(value);
          }}
          onBlur={() => runValidationTasks("address", address)}
          errorMessage={errors.address?.errorMessage}
          hasError={errors.address?.hasError}
          {...getOverrideProps(overrides, "address")}
        ></TextField>
        <TextField
          label="Phone"
          isRequired={false}
          isReadOnly={false}
          type="tel"
          value={phone}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                customId,
                name,
                abbreviation,
                address,
                phone: value,
                country,
                city,
                description,
              };
              const result = onChange(modelFields);
              value = result?.phone ?? value;
            }
            if (errors.phone?.hasError) {
              runValidationTasks("phone", value);
            }
            setPhone(value);
          }}
          onBlur={() => runValidationTasks("phone", phone)}
          errorMessage={errors.phone?.errorMessage}
          hasError={errors.phone?.hasError}
          {...getOverrideProps(overrides, "phone")}
        ></TextField>
      </Grid>
      <Grid
        columnGap="inherit"
        rowGap="inherit"
        templateColumns="repeat(2, auto)"
        {...getOverrideProps(overrides, "RowGrid2")}
      >
        <TextField
          label="Country"
          isRequired={false}
          isReadOnly={false}
          value={country}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                customId,
                name,
                abbreviation,
                address,
                phone,
                country: value,
                city,
                description,
              };
              const result = onChange(modelFields);
              value = result?.country ?? value;
            }
            if (errors.country?.hasError) {
              runValidationTasks("country", value);
            }
            setCountry(value);
          }}
          onBlur={() => runValidationTasks("country", country)}
          errorMessage={errors.country?.errorMessage}
          hasError={errors.country?.hasError}
          {...getOverrideProps(overrides, "country")}
        ></TextField>
        <TextField
          label="City"
          isRequired={false}
          isReadOnly={false}
          value={city}
          onChange={(e) => {
            let { value } = e.target;
            if (onChange) {
              const modelFields = {
                customId,
                name,
                abbreviation,
                address,
                phone,
                country,
                city: value,
                description,
              };
              const result = onChange(modelFields);
              value = result?.city ?? value;
            }
            if (errors.city?.hasError) {
              runValidationTasks("city", value);
            }
            setCity(value);
          }}
          onBlur={() => runValidationTasks("city", city)}
          errorMessage={errors.city?.errorMessage}
          hasError={errors.city?.hasError}
          {...getOverrideProps(overrides, "city")}
        ></TextField>
      </Grid>
      <TextAreaField
        label="Description"
        isRequired={false}
        isReadOnly={false}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              customId,
              name,
              abbreviation,
              address,
              phone,
              country,
              city,
              description: value,
            };
            const result = onChange(modelFields);
            value = result?.description ?? value;
          }
          if (errors.description?.hasError) {
            runValidationTasks("description", value);
          }
          setDescription(value);
        }}
        onBlur={() => runValidationTasks("description", description)}
        errorMessage={errors.description?.errorMessage}
        hasError={errors.description?.hasError}
        {...getOverrideProps(overrides, "description")}
      ></TextAreaField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
